export default "__VITE_ASSET__DZXTabMK__"